import { Component, OnInit, ChangeDetectorRef, ElementRef, ViewChild, HostListener } from '@angular/core';
import { Approved, Remark, Specification, sendEmailmultiple } from '../../../service/modal/approved';
import { ApprovedService } from '../../../service/apiservice/approved.service';
import { Sub } from '../../../service/modal/pendingrequest';
import { PendingRequestService } from '../../../service/apiservice/pendingrequest.service';
import { Globals } from '../../../globals';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormGroup, Validators, AbstractControl, FormControl, NgForm, FormBuilder } from '@angular/forms';
declare var $;
declare function info_noti(msg: any): any;
@Component({
  selector: 'app-getotpallapproved',
  templateUrl: './getotpallapproved.component.html',
  styleUrls: ['./getotpallapproved.component.css']
})
export class GetotpallapprovedComponent implements OnInit {
  approvedGrid: Approved[] = new Array();
  approvedViewData: Approved = new Approved();
  addApprovedHealthCard: Approved = new Approved();
  showActions: boolean = false;
  @ViewChild('addForm') addForm: any;
  @ViewChild('AddCloseForm') addCloseForm: ElementRef;
  @ViewChild('AttachmentCloseForm') AttachmentCloseForm: ElementRef;

  eyeIcon: string = "zmdi-eye-off";
  starIcon: string = "zmdi-star-outline";

  eyeIconViewData: string = "zmdi-eye-off";
  starIconViewData: string = "zmdi-star-outline";
  //subject DropDown//
  subjectDropDown: any;
  subjectDropDown_SelectedId: number[];
  //subject DropDown//

  //Specification DropDown//
  specificationDropDown: any;
  specificationDropDown_SelectedId: number[];
  //Specification DropDown//

  //Remark DropDown//
  remarkDropDown: any;
  remarkDropDown_SelectedId: number[];
  //Remark DropDown//
  todayDate: any;
  selectedMailList = [];
  selectedActionList: Approved[] = new Array();;
  appvar: Approved;
  hoveredIndex;
  approvedObjActionShow = new Approved();
  checkClickCount = 0;
  allApprovedAttachmentDataShow: any
  allApprovedAttachmentData: any
  //multiple email forward
  emailId;
  sendEmailmultiple = new sendEmailmultiple;
  constructor(private fb: FormBuilder,private spinner: NgxSpinnerService, private datePipe: DatePipe, private router: Router, private _approvedService: ApprovedService, private _pendingRequestService: PendingRequestService,
    private chRef: ChangeDetectorRef, private global: Globals) { }

  ngOnInit() {
    localStorage.setItem("Active Route", this.router.url);
    this.GetApproved_Grid();
    this.todayDate = new Date();
    $(".modal-wide").on("show.bs.modal", function () {
      var height = $(window).height() - 80;
      $(this).find(".modal-body").css("max-height", height);
    });
    this.loadSendEmailForm();
  }
  checkYear(data): Boolean {
    let userDate = new Date(data);
    if (userDate.getFullYear() == this.todayDate.getFullYear()) {
      return true;
    }
    else {
      return false;
    }
  }
  GetApproved_Grid() {
    // this.spinner.show();
    this._approvedService.GetAllApprovedList()
      .subscribe((response) => {

        if ($.fn.dataTable.isDataTable('#allApprovedDatatable')) {
          $('#allApprovedDatatable').dataTable().fnClearTable();
          $('#allApprovedDatatable').dataTable().fnDestroy();
        }

        if ($.fn.dataTable.isDataTable('#allApprovedDatatable_IsMobile')) {
          $('#allApprovedDatatable_IsMobile').dataTable().fnClearTable();
          $('#allApprovedDatatable_IsMobile').dataTable().fnDestroy();
        }
        // this.spinner.hide();
        Object.assign(this.approvedGrid, response);
        this.approvedGrid.forEach((element) => {

          if (element.sub.length == 0) {
            element.subBindGrid = "";
          } else {
            element.sub.forEach((elem) => {
              if (element.subBindGrid == undefined) {
                element.subBindGrid = elem.name
              }
              else {
                element.subBindGrid = element.subBindGrid + ',' + elem.name;
              }
              // element.subBindGrid="";
            })
          }
          if (element.spec.length == 0) {
            element.specBindGrid = "";
          } else {
            element.spec.forEach((elem) => {
              if (element.specBindGrid == undefined) { element.specBindGrid = elem.name }
              else { element.specBindGrid = element.specBindGrid + ',' + elem.name; }
            })
          }
          if (element.remark.length == 0) {
            element.remarkBindGrid = "";
          } else {
            element.remark.forEach((elem) => {
              if (element.remarkBindGrid == undefined) { element.remarkBindGrid = elem.name }
              else { element.remarkBindGrid = element.remarkBindGrid + ',' + elem.name; }
            })
          }
        });

        this.chRef.detectChanges();
        $("#allApprovedDatatable").DataTable({
          "paging": false,
          "info": false,
          "order": [[8, 'desc']],
          'columnDefs': [{ 'orderable': false, 'targets': 0 }],
          dom: 'Bfrtip',
          buttons: [
            { extend: 'pdf', title: 'AllApproved Pdf', attr: { id: "pdfBtn" }, exportOptions: { columns: [2, 3, 4, 5, 6, 7, 9] } },
            { extend: 'excel', title: 'AllApproved Excel', attr: { id: "excelBtn" }, exportOptions: { columns: [2, 3, 4, 5, 6, 7, 9] } }
          ],
          "fnDrawCallback": function () {
            var table = $('#allApprovedDatatable').DataTable();
            $(table.buttons('.buttons-pdf').nodes()).css("display", "none");
            $(table.buttons('.buttons-excel').nodes()).css("display", "none");
          }
        });
        $("#allApprovedDatatable_filter").hide();

        $("#allApprovedDatatable_IsMobile").DataTable({
          "paging": false,
          "info": false,
          "order": [[3, 'desc']],
          'columnDefs': [{ 'orderable': false, 'targets': 0 }],
          dom: 'Bfrtip',
          buttons: [
            { extend: 'pdf', title: 'AllApproved Pdf', attr: { id: "pdfBtn_IsMobile" }, exportOptions: { columns: [2, 4] } },
            { extend: 'excel', title: 'AllApproved Excel', attr: { id: "excelBtn_IsMobile" }, exportOptions: { columns: [2, 4] } }
          ],
          "fnDrawCallback": function () {
            var table = $('#allApprovedDatatable_IsMobile').DataTable();
            $(table.buttons('.buttons-pdf').nodes()).css("display", "none");
            $(table.buttons('.buttons-excel').nodes()).css("display", "none");
          }
        });
        $("#allApprovedDatatable_IsMobile_filter").hide();
      },
        error => {
          console.log(error);
        })
  }

  ExportExcel() {
    $("#excelBtn").click();
  }

  ExportPdf() {
    $("#pdfBtn").click();
  }
  ExportExcel_IsMobile() {
    $("#excelBtn_IsMobile").click();
  }

  ExportPdf_IsMobile() {
    $("#pdfBtn_IsMobile").click();
  }



  ViewDataBind(data: Approved) {
    Object.assign(this.approvedViewData, data);
    console.log(this.approvedViewData);
  }

  //Add approved
  Add_CloseClick() {
    this.addForm.resetForm();
  }
  Attachment_CloseClick() {

  }
  Add_PreDataBind() {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
    var changedate = this.datePipe.transform(localISOTime, 'yyyy-MM-ddTHH:mm');
    this.addApprovedHealthCard.dateTime = changedate;
    //Subject Dropdown
    this._pendingRequestService.GetAllSubject()
      .subscribe((response) => {
        this.subjectDropDown = response;
        console.log(response);
      },
        error => {
          console.log(error);
        })

    //Specification Dropdown
    this._pendingRequestService.GetAllSpecification()
      .subscribe((response) => {
        this.specificationDropDown = response;
        console.log(response);
      },
        error => {
          console.log(error);
        })

    //Specification Dropdown
    this._pendingRequestService.GetAllRemark()
      .subscribe((response) => {
        this.remarkDropDown = response;
        console.log(response);
      },
        error => {
          console.log(error);
        })
  }

  Eye_Click() {
    this.eyeIcon = this.eyeIcon == "zmdi-eye" ? "zmdi-eye-off" : "zmdi-eye";
    this.addApprovedHealthCard.hide = this.eyeIcon == "zmdi-eye" ? true : false;
  }

  Star_Click() {
    this.starIcon = this.starIcon == "zmdi-star" ? "zmdi-star-outline" : "zmdi-star";
    this.addApprovedHealthCard.star = this.starIcon == "zmdi-star" ? true : false;
  }

  ApprovedHealthSubmit() {
    debugger;
    //sub data
    var localsub: Sub[] = new Array();
    for (let data of this.subjectDropDown_SelectedId) {
      if (isNaN(data)) {
        var newSub: Sub = {
          subjectId: 0,
          name: data.toString(),
        }
        localsub.push(newSub);
      }
      else {
        var oldSub: Sub = {
          subjectId: data,
          name: this.subjectDropDown.find(a => a.subjectId == data).name,
        }
        localsub.push(oldSub);
      }
    }

    //spec data
    var localspec: Specification[] = new Array();
    for (let data of this.specificationDropDown_SelectedId) {
      if (isNaN(data)) {
        var newSpec: Specification = {
          specificationId: 0,
          name: data.toString(),
        }
        localspec.push(newSpec);
      }
      else {
        var oldSpec: Specification = {
          specificationId: data,
          name: this.specificationDropDown.find(a => a.specificationId == data).name,
        }
        localspec.push(oldSpec);
      }
    }

    //remark data
    var localrmk: Remark[] = new Array();
    for (let data of this.remarkDropDown_SelectedId) {
      if (isNaN(data)) {
        var newRmk: Remark = {
          remarkId: 0,
          name: data.toString(),
        }
        localrmk.push(newRmk);
      }
      else {
        var oldRmk: Remark = {
          remarkId: data,
          name: this.remarkDropDown.find(a => a.remarkId == data).name,
        }
        localrmk.push(oldRmk);
      }
    }

    this.addApprovedHealthCard.sub = localsub;
    this.addApprovedHealthCard.spec = localspec;
    this.addApprovedHealthCard.remark = localrmk;

    this._approvedService.AddApproved_HealthCard(this.addApprovedHealthCard)
      .subscribe((response) => {
        this.addForm.resetForm();
        this.addCloseForm.nativeElement.click();
        this.GetApproved_Grid();
        // this.selectedFiles = [];
        // this.attchmentList = [];
        // Globals.attachmentStatus == false;
        this.eyeIcon = "zmdi-eye-off";
        this.starIcon = "zmdi-star-outline";
      },
        error => {
          info_noti(error);
        })
  }

  addCancelClick() {
    this.addForm.resetForm();
  }
  //Add approved


  //DropDown Functions//
  subjectDropDown_Added = (term) => ({ subjectId: term, name: term });
  specificationDropDown_Added = (term) => ({ specificationId: term, name: term });
  remarkDropDown_Added = (term) => ({ remarkId: term, name: term });
  //DropDown Functions//

  // checkboxChanged(event, obj) {
  //   debugger;
  //   if (event.target.checked) {
  //     this.selectedMailList.push(event.target.value);

  //   }
  //   else {
  //     this.selectedMailList.splice(this.selectedMailList.indexOf(event.target.value), 1);
  //   }
  //   this.selectedMailList = Array.from(new Set(this.selectedMailList));

  //   if (this.selectedMailList.length > 0) {
  //     this.showActions = true;
  //     if (this.checkClickCount == 0) {
  //       this.checkClickCount = 1;
  //       this.approvedObjActionShow = obj;
  //     }
  //   }
  //   else {
  //     this.checkClickCount = 0;
  //     this.approvedObjActionShow = null;
  //     this.showActions = false;
  //   }
  // }


  checkboxChanged(event, obj, status, allSelectedList, type) {
    debugger;
    if (type == "mobile") {
      if (status == "selectAll") {
        if (event.target.checked) {
          var i = 1;
          allSelectedList.forEach(element => {
            this.selectedMailList.push(element.appEmailId);
            $('#checkboxm' + i).prop("checked", true);
            i++;
          })
        } else {

          var i = 1;

          allSelectedList.forEach(element => {
            this.selectedMailList.splice(this.selectedMailList.indexOf(element.appEmailId, 1));

            $('#checkboxm' + i).prop("checked", false);
            i++;
          })
        }

      } else {

        if (event.target.checked) {
          this.selectedMailList.push(obj.appEmailId);
          if (this.selectedMailList.length == this.approvedGrid.length) {
            $('#selectAllm').prop("checked", true);
          }

        }
        else {
          $('#selectAllm').prop("checked", false);
          this.selectedMailList.splice(this.selectedMailList.indexOf(obj.appEmailId), 1);
        }
      }
      this.selectedMailList = Array.from(new Set(this.selectedMailList));

      if (this.selectedMailList.length > 0) {
        this.showActions = true;
        if (this.checkClickCount == 0) {
          this.checkClickCount = 1;
          this.approvedObjActionShow = obj;
        }
      }
      else {
        this.checkClickCount = 0;
        this.approvedObjActionShow = null;
        this.showActions = false;
      }
    } else {
      if (status == "selectAll") {
        if (event.target.checked) {
          var i = 1;
          allSelectedList.forEach(element => {
            this.selectedMailList.push(element.appEmailId);
            $('#checkbox' + i).prop("checked", true);
            i++;
          })
        } else {

          var i = 1;

          allSelectedList.forEach(element => {
            this.selectedMailList.splice(this.selectedMailList.indexOf(element.appEmailId, 1));

            $('#checkbox' + i).prop("checked", false);
            i++;
          })
        }

      } else {

        if (event.target.checked) {
          this.selectedMailList.push(obj.appEmailId);
          if (this.selectedMailList.length == this.approvedGrid.length) {
            $('#selectAll').prop("checked", true);
          }

        }
        else {
          $('#selectAll').prop("checked", false);
          this.selectedMailList.splice(this.selectedMailList.indexOf(obj.appEmailId), 1);
        }
      }
      this.selectedMailList = Array.from(new Set(this.selectedMailList));

      if (this.selectedMailList.length > 0) {
        this.showActions = true;
        if (this.checkClickCount == 0) {
          this.checkClickCount = 1;
          this.approvedObjActionShow = obj;
        }
      }
      else {
        this.checkClickCount = 0;
        this.approvedObjActionShow = null;
        this.showActions = false;
      }
    }

  }



  StarClick(appEmailId, star, status) {
    debugger;
    this._approvedService.starUnstar(appEmailId, star)
      .subscribe((response) => {
        // console.log(response);

        if (star == 1) {
          info_noti('Starred Success...');
        } else {
          info_noti('UnStarred Success...');
        }
        this.GetApproved_Grid();
      })
  }


  HideClick(appEmailId, hide) {
    this._approvedService.hideUnhide(appEmailId, hide)
      .subscribe((response) => {
        info_noti('Hidden Success...');
        this.GetApproved_Grid();
      })
  }
  //Delete
  DeleteApproved(id: any, status) {
    debugger;
    if (status == 'ViewModal') {
      $("#ViewModal").modal("hide");
      $("body").removeClass('modal-open');
      $('.modal-backdrop').remove();
    }
    this._approvedService.Delete_HealthCard(id)
      .subscribe((response) => {
        debugger;
        info_noti('Deleted Success...');
        this.GetApproved_Grid();
      });
  }


  //multiple delete
  multipleDelete() {
    debugger;
    for (var i = 0; i < this.selectedMailList.length; i++) {
      this.appvar = new Approved();
      this.appvar.appEmailId = Number(this.selectedMailList[i]);
      this.selectedActionList[i] = this.appvar;
    }
    this._approvedService.deleteMultiple(this.selectedActionList).subscribe((response) => {
      info_noti('Deleted Success...');
      this.selectedMailList.length = 0;
      this.appvar
      this.selectedActionList.length = 0;
      if (this.selectedMailList.length > 0) {
        this.showActions = true;
      }
      else {
        this.approvedObjActionShow = null;
        this.checkClickCount = 0;
        this.showActions = false;
      }
      $('#selectAll').prop("checked", false);
      $('#selectAllm').prop("checked", false);
      this.GetApproved_Grid();
    }, error => { info_noti(error); }
    );
    console.log(this.selectedMailList);
  }


  multipleStar(flag: boolean) {
    debugger;

    for (var i = 0; i < this.selectedMailList.length; i++) {
      this.appvar = new Approved();
      this.appvar.appEmailId = Number(this.selectedMailList[i]);
      this.appvar.star = true;

      this.selectedActionList[i] = this.appvar;
    }
    this._approvedService.starMultiple(this.selectedActionList).subscribe((response) => {
      info_noti('Starred Success...');
      //  info_noti("Starred Success...");
      this.selectedMailList.length = 0;
      this.appvar
      this.selectedActionList.length = 0;
      if (this.selectedMailList.length > 0) {
        this.showActions = flag;
      }
      else {
        this.approvedObjActionShow = null;
        this.showActions = false;
        this.checkClickCount = 0;
      }
      $('#selectAll').prop("checked", false);
      $('#selectAllm').prop("checked", false);
      this.GetApproved_Grid();
    }, error => { info_noti(error); }
    );


    console.log(this.selectedMailList);

  }
  multipleEye(flag: boolean) {
    debugger;
    for (var i = 0; i < this.selectedMailList.length; i++) {
      this.appvar = new Approved();
      this.appvar.appEmailId = Number(this.selectedMailList[i]);
      this.appvar.hide = flag;
      this.selectedActionList[i] = this.appvar;
    }
    this._approvedService.hideMultiple(this.selectedActionList).subscribe((response) => {
      info_noti('Hidden Success...');
      this.selectedMailList.length = 0;
      this.appvar
      this.selectedActionList.length = 0;
      if (this.selectedMailList.length > 0) {
        this.showActions = true;
      }
      else {
        this.approvedObjActionShow = null;
        this.showActions = false;
        this.checkClickCount = 0;
      }
      $('#selectAll').prop("checked", false);
      $('#selectAllm').prop("checked", false);
      this.GetApproved_Grid();
    }, error => { info_noti(error); }
    );
    console.log(this.selectedMailList);
  }
  AttachmentShow_DataBind(data) {
    this.allApprovedAttachmentDataShow = data;

  }
  Attachment_DataBind(data: any) {
    this.allApprovedAttachmentData = data;
  }


  enteredEmailIDForForwordEmail(emailId) {
    this.emailId = emailId;
  }
  multipleForword(emailId, form: NgForm) {
    if (emailId != "") {
      $("#multipleForwordBtn").attr("disabled", true);
      for (var i = 0; i < this.selectedMailList.length; i++) {
        this.appvar = new Approved();
        this.appvar.appEmailId = Number(this.selectedMailList[i]);
        this.selectedActionList[i] = this.appvar;
      }

      this.sendEmailmultiple.approved = this.selectedActionList;
      // this.sendEmailmultiple.emailid = emailId;

      this.sendEmailmultiple.emailid = this.sendEmailForm.controls['toAddress'].value;


      this._approvedService.forwordMultiple(this.sendEmailmultiple).subscribe((response) => {
        info_noti("Email Send Success...");
        $("#multipleForwordBtn").attr("disabled", false);
        $('#sendForwordemail').val('');
        $("#sendEmailForMultipleForword").modal("hide");
        $("body").removeClass('modal-open');
        $('.modal-backdrop').remove();
        this.selectedMailList.length = 0;

        this.selectedActionList.length = 0;
        if (this.selectedMailList.length > 0) {
          this.showActions = true;
        }
        else {
          this.approvedObjActionShow = null;
          this.showActions = false;
          this.checkClickCount = 0;
          this.sendEmailmultiple = new sendEmailmultiple;
        }
        $('#selectAll').prop("checked", false);
        $('#selectAllm').prop("checked", false);
        this.GetApproved_Grid();

      
      }, error => {
        info_noti("Email Not send");
       
        $("#sendEmailForMultipleForword").modal("hide");
        $("body").removeClass('modal-open');
        $('.modal-backdrop').remove();
      }
      );
      console.log(this.selectedMailList);
    } else {
      this.emailId = '';
      console.log(this.emailId);
    }


  }





  sendEmailForm: FormGroup;
  loadSendEmailForm() {
    this.sendEmailForm = this.fb.group({
      'toAddress': ['', [Validators.required, this.commaSepEmail]]
    });
  }

  send(value) {
    console.log(value);
  }

  commaSepEmail = (control: AbstractControl): { [key: string]: any } | null => {
    const emails = control.value.split(',');
    const forbidden = emails.some(email => Validators.email(new FormControl(email)));
    console.log(forbidden);
    return forbidden ? { 'toAddress': { value: control.value } } : null;
  };


  sendForwordEmailOpen() {
    this.loadSendEmailForm();
    $('#sendForwordemail').focus();

  }


  forwordEmailEnter(sendForwordemail, form: NgForm) {
    $('#multipleForwordBtn').focus();
    this.multipleForword(sendForwordemail, form);
  }
  sendMailClose() {
    $('#sendForwordemail').val('');
    this.emailId = "";
  }
  updateUsingViewModel(id) {
    $("#ViewModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    this.router.navigate(['/dashboard/updatehc/' + id + '/approved']);
  }


  downloadFile(path) {
    window.open(path, '_self');
  }

  //browser back button or mobile back button
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {

    $("#AddApprovedModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#ViewModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#HideModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#AttachmentModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#attchmentShowModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#sendEmailForMultipleForword").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

  }
  Eye_ClickViewData(appEmailId) {
    debugger

    if (this.eyeIconViewData == "zmdi-eye") {
      this.eyeIconViewData = "zmdi-eye-off";
      this.HideClick(appEmailId, 0);
    } else {
      this.eyeIconViewData = "zmdi-eye";
      this.HideClick(appEmailId, 1);
    }


  }
  Star_ClickViewData(appEmailId) {
    debugger

    if (this.starIconViewData == "zmdi-star") {
      this.starIconViewData = "zmdi-star-outline";
      this.StarClick(appEmailId, 0, 'viewData');
    } else {
      this.starIconViewData = "zmdi-star";
      this.StarClick(appEmailId, 1, 'viewData');
    }

  }







}
